import {CSSProperties, ReactElement, ReactNode} from "react";
import {ReactComponent as Grip} from "@zendeskgarden/svg-icons/src/16/grip.svg";
import {Button} from "@zendeskgarden/react-buttons";
import * as css from "./styles/DnDKitDraggable.module.scss";
import {Data, useDraggable} from "@dnd-kit/core";

export interface DnDKitDraggableProps {
    id: string;
    children: ReactNode | ReactNode[];
    data?: Data;
}

export function DnDKitDraggable(props: DnDKitDraggableProps): ReactElement {
    const {attributes, listeners, setNodeRef, isDragging} = useDraggable({
        id: props.id,
        data: props.data
    });

    const style: CSSProperties = {};
    if(isDragging) {
        style["visibility"] = "hidden";
    }

    return <div ref={setNodeRef} className={css.dndkitDraggable} style={style}>
        <div>
            <Button isBasic aria-label="Grip here to drag." {...listeners} {...attributes}><Grip /></Button>
        </div>
        <div>
            {props.children}
        </div>
    </div>;
}